<template>
  <div :class="theme">
    <div class="p-app">
      <div class="p-app-header">
        <slot name="header"></slot>
      </div>
      <div class="p-app-content">
        <slot></slot>
      </div>
      <footer v-if="hasFooterSlot" class="p-app-footer">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      theme: { default: undefined, type: String },
    },
    computed: {
      hasFooterSlot() {
        return !!(this.$slots as any).footer;
      },
    },
    methods: {
    },
  });
</script>
